import { z } from "zod";
import { PlantPlotSignal } from "./admin.js";
import { ZDate } from "./ZDate.js";
import { zArr, zBool, zNullable, zNum, zObj, zOptional, zStr } from "./zodWrapper.js";
export const OpModeEvent = zObj({
    opModeId: zNullable(zNum()),
    opModeName: zStr(),
    subsystemId: zNum(),
    subsystemName: zStr(),
    timestamp: zStr(),
    // timestamp: ZDate,
});
export var DeviationSeverity;
(function (DeviationSeverity) {
    DeviationSeverity["YELLOW"] = "yellow";
    DeviationSeverity["RED"] = "red";
})(DeviationSeverity || (DeviationSeverity = {}));
export const DeviationSeverityEnum = z.nativeEnum(DeviationSeverity);
export const DeviationEvent = zObj({
    subsystemName: zStr(),
    subsystemId: zNum(),
    categoryName: zStr(),
    timestamp: zStr(),
    severity: zOptional(DeviationSeverityEnum),
});
export var PlantOpenState;
(function (PlantOpenState) {
    PlantOpenState["OPEN"] = "open";
    PlantOpenState["CLOSED"] = "closed";
})(PlantOpenState || (PlantOpenState = {}));
export const PlantOpenStateEnum = z.nativeEnum(PlantOpenState);
export const PlantOpenStateEvent = zObj({ state: PlantOpenStateEnum, timestamp: zStr() });
export const Segment = zObj({ color: zStr(), timestamp: zStr() });
export var OperationModeConditionType;
(function (OperationModeConditionType) {
    OperationModeConditionType["EQUALS"] = "eq";
    OperationModeConditionType["GREATER_THAN"] = "gt";
    OperationModeConditionType["LESS_THAN"] = "lt";
    OperationModeConditionType["NE"] = "ne";
    OperationModeConditionType["GE"] = "ge";
    OperationModeConditionType["LE"] = "le";
})(OperationModeConditionType || (OperationModeConditionType = {}));
export const OperationModeConditionTypeEnum = z.nativeEnum(OperationModeConditionType);
export const SubsystemConstraint = zObj({
    sensorId: zNum(),
    conditionValue: zNum(),
    conditionType: OperationModeConditionTypeEnum,
});
export const OpModeConstraints = zObj({
    subsystemId: zNum(),
    constraints: zOptional(zArr(SubsystemConstraint)),
});
export const OpModeGetLiveArgs = zObj({ plantIds: zArr(zNum()) });
export const OpModeGetLiveResponse = z.object({
    plants: z.array(z.object({
        plantId: z.number(),
        opModeName: z.string(),
    })),
});
export const GetOpModeEventsArgs = zObj({
    plantId: zNum(),
    from: ZDate,
    to: ZDate,
});
export const OpModeLiveData = zObj({
    deviationEvents: zOptional(zArr(DeviationEvent)),
    fishCount: zOptional(zNum()),
    /**
     * @deprecated implementation removed
     */
    openState: zOptional(PlantOpenStateEnum),
    opModeEvents: zOptional(zArr(OpModeEvent)),
    plantId: zNum(),
    waterInWell: zOptional(zBool()),
});
export const OpModeLiveDataCollection = zArr(OpModeLiveData);
export const OpModeEventData = zObj({
    opModeEvents: zOptional(zArr(OpModeEvent)),
    deviationEvents: zOptional(zArr(DeviationEvent)),
    /**
     * @deprecated implementation removed
     */
    openStateEvents: zOptional(zArr(PlantOpenStateEvent)),
    segments: zOptional(zArr(Segment)),
});
export const ResetOpModesArgs = zObj({ schemaName: zStr() });
export const OpModeGetConstraintsArgs = zObj({ plantId: zNum() });
export const OpModeList = zArr(zObj({
    id: zNum(),
    name: zStr(),
}));
export const OpModeGetListArgs = zObj({
    plantId: zNum(),
});
export const OpModeAddPlotArgs = z.object({
    plotName: zStr(),
    opModeId: zNum(),
    signals: zArr(PlantPlotSignal),
});
export const OpModeAddPlot = zObj({
    id: zNum(),
});
export const OpModeGetPlotsArgs = z.object({
    opModeId: zNum(),
});
export const OpModeResetPlotsArgs = z.object({ opModeId: zNum() });
//# sourceMappingURL=opmode.js.map